import type { UnremindMeRequest } from "@/modules/events/types/eventDetailsApi"
import type { UseMutationResult } from "@tanstack/react-query"

import { useMutation } from "@tanstack/react-query"

import { getUnremindMe } from "@/modules/events/api/getUnremindMe"

export const useUnremindMe = (): UseMutationResult<void, Error, UnremindMeRequest> =>
  useMutation<void, Error, UnremindMeRequest>({ mutationFn: getUnremindMe })
